import { useContext } from 'react'
import { EnrollStepComposerContext } from '../contexts'

export const useEnrollStepComposerContext = () =>
  useContext(EnrollStepComposerContext)
